<section #sectionRef>
  <div class="text-center w-100" *ngIf="!isOnBusinessPlan">
    <ngb-alert [dismissible]="false">
      The features on this page are not available on the {{ plansAlertData.notAvailableForPlan }}.
      <a routerLink="/settings/location/billing" class="alert-link" [innerText]="plansAlertData.linkText"></a>
      {{ plansAlertData.afterLinkText }}
    </ngb-alert>
  </div>

  <div class="top-menu border-border" #topMenu>
    <div class="d-flex mb-2">
      <tablesready-floorplan-switcher
        [items]="graphCanvasView.floorPlanItems"
        [showEditButton]="graphCanvasView.showFloorsEdit"
        [disabled]="!isOnBusinessPlan"
        (floorChange)="floorPlanSwitcherChange($event)"
        (editPlan)="graphCanvasView.planEdit.emit($event)"
      ></tablesready-floorplan-switcher>

      <div class="ml-3 background-canvas border-border parties-filter" *ngIf="service.floorPlans?.length > 1">
        <p class="my-0 mr-2 user-select-none">Current floor plan parties only</p>
        <tablesready-switcher
          [ngModel]="currentFloorPlanPartiesOnly"
          (ngModelChange)="currentFloorPlanPartiesSwitchChange($event)"
        ></tablesready-switcher>
      </div>
    </div>

    <div class="filters">
      <div class="pr-4">
        <tablesready-search-bar
          #searchBarRef
          [placeholder]="'Search ' + reservationPluralLabel"
          [inputFieldHidden]="true"
          (search)="searchParties($event)"
        ></tablesready-search-bar>
      </div>

      <div class="d-flex flex-row">
        <div class="mr-2">
          <button class="btn btn-success user-select-none" (click)="setCurrentDate()">Today</button>
        </div>

        <div class="ml-2 mr-1">
          <button class="btn btn-light user-select-none" (click)="selectPreviousDay()">
            <tr-icon [icon]="icon.arrowLeft" [size]="iconSize.small"></tr-icon>
          </button>
        </div>

        <div class="input-group datepicker-box background-background">
          <button class="btn btn-info btn-light no-round-right user-select-none" (click)="datepicker.toggle()">
            <tr-icon [icon]="icon.date" [size]="iconSize.medium"></tr-icon>
          </button>
          <input
            id="reservation-date-input"
            type="text"
            name="date"
            class="form-control no-round-left date-input user-select-none"
            placeholder="Select date"
            autocomplete="off"
            ngbDatepicker
            container="body"
            [minDate]="minDate"
            [weekdays]="true"
            [firstDayOfWeek]="7"
            #datepicker="ngbDatepicker"
            [(ngModel)]="reservationDateFilter"
            (ngModelChange)="changeDate()"
            #partyDate="ngModel"
            (click)="datepicker.toggle()"
          />
        </div>

        <div class="ml-1">
          <button class="btn btn-light user-select-none" (click)="selectNextDay()">
            <tr-icon [icon]="icon.arrowRight" [size]="iconSize.small"></tr-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="content">
    <div class="tip-shadow" *ngIf="isSidebarOpen" [style.left.px]="isSidebarOpen ? sidebar.offsetWidth : 0"></div>

    <div
      #sidebar
      class="sidebar border-border background-background"
      [style.min-width]="isSidebarOpen ? '384px' : '0'"
      [style.width]="isSidebarOpen ? '384px' : '0'"
    >
      <div class="tabs border-border">
        <tablesready-shared-tabs
                [tabIndex]="showTableInfoCards ? undefined : tabIndex"
                [items]="tabs"
                [showBorders]="false"
                (tabChange)="tabChanged($event)"
        ></tablesready-shared-tabs>
      </div>

      <div class="sidebar-content">
        <ng-container *ngIf="showTableInfoCards || selectedPartyId">
          <div class="table-info-header">
            <tr-icon
              class="mr-1"
              [icon]="icon.cancel"
              [size]="iconSize.medium"
              (click)="closePartyOrTableInfo()"
            ></tr-icon>

            <div *ngIf="selectedPartyId && selectedPartyResourceName" class="chip background-hover user-select-none"><b>{{ selectedPartyResourceName }}</b></div>
            <div *ngIf="!selectedPartyId" class="chip background-hover user-select-none">Selected: <b class="pl-1">{{ resourceNameMap[selectedResourceId] }}</b></div>
          </div>

          <ng-container *ngIf="selectedResourceId">
            <div class="timeline">
              <tr-timeline
                [resourceId]="selectedResourceId"
                [timezone]="locationTimezone"
                [showCurrentTime]="isDateSetForToday"
                [partiesToShow]="cardsToDisplay[FloorPlanPartyTab.all]"
                [tableColors]="cardTypeColorMap"
              ></tr-timeline>
            </div>

            <div class="timeline-actions">
              <button class="btn btn-outline-info mr-2" (click)="addParty(true, selectedResourceId)">Seat Walk-in</button>
              <button class="btn btn-outline-success ml-2" (click)="addParty(false, selectedResourceId)">Add reservation</button>
            </div>
          </ng-container>
        </ng-container>

        <p class="px-3 user-select-none" *ngIf="displayNoParties">
          No {{ customerPlural }}
        </p>
        <ng-container *ngFor="let item of cardsToDisplay[selectedResourceId ? FloorPlanPartyTab.all : tabs[tabIndex]?.title]">
          <tablesready-floorplan-card
            *ngIf="!showTableInfoCards && !selectedPartyId"
            [showStatus]="item.tabType === tabType.booked"
            [type]="item.cardType"
            [partyId]="item._id"
            [iconColor]="color.primary"
            [titleColor]="cardTypeColorMap[item.cardType]"
            [quotedTime]="item?.quoted_time"
            [seatedTime]="item?.seated_time"
            [checkInTime]="item?.checkin_time"
            [duration]="item?.duration"
            [resourceName]="item?.resourceName"
            [resourceIds]="item?.resources"
            [customerName]="item?.name"
            [partySize]="item?.size"
            [partyBadge]="getPartyById(item._id)"
            [timezone]="locationTimezone"
            [createTime]="item?.created_time"
            [isReservation]="item?.type === partyTypes.reservation"
            [stripeData]="item?.stripeData"
            (cardSelected)="selectTableByResourceId(item.resources, item._id)"
          ></tablesready-floorplan-card>

          <tablesready-table-info
            *ngIf="(!!selectedPartyId && selectedPartyId === item._id) || showTableInfoCards"
            [type]="item.cardType"
            [name]="item.name"
            [size]="item.size"
            [chipText]="item.cardType"
            [currentFloorPlanId]="selectedFloorPlanId"
            [showAlsoTables]="!selectedPartyId"
            [selectedResourceId]="selectedResourceId"
            [notificationTime]="notificationTime"
            [voicePageNotificationEnabled]="voicePageNotificationEnabled"
            [timezone]="locationTimezone"
            [chipColor]="cardTypeColorMap[item.cardType]"
            [party]="item"
            [actions]="item.actions"
            [country]="locationCountry"
            [iconColor]="iconColor"
            [partyBadge]="getPartyById(item._id)"
            [createTime]="item?.created_time"
            [isMobile]="isMobile"
            [isReservation]="item?.type === partyTypes.reservation"
            [stripeData]="item?.stripeData"
            (deleteParty)="deleteParty(item)"
          ></tablesready-table-info>
        </ng-container>
      </div>
    </div>

    <div class="canvas-wrapper position-relative">
      <div *ngIf="showTablesWarning" class="alert-wrapper background-background user-select-none">
        <h1 class="user-select-none">Please, add tables to your FloorPlan on <a (click)="navigateToFloorPlanSetup()">Settings/Resources</a> page.</h1>
      </div>

      <div *ngIf="showFloorPlansWarning" class="alert-wrapper background-background user-select-none">
        <h1 class="user-select-none">Please, add your first FloorPlan on <a (click)="navigateToFloorPlanSetup()">Settings/Resources</a> page.</h1>
      </div>

      <div class="toggle-tip">
        <div class="tip background-background user-select-none" (click)="setSidebarOpen(!isSidebarOpen)">
          <tr-icon *ngIf="!isSidebarOpen" [icon]="icon.arrowRight"></tr-icon>
          <tr-icon *ngIf="isSidebarOpen" [icon]="icon.arrowLeft"></tr-icon>
        </div>
      </div>

      <frontend-canvas
        #graphCanvasView
        [canvasId]="'canvas-view'"
        [leftLayoutOffsetPx]="leftLayoutOffset"
        [canvasAreaHeightPx]="sectionRef.offsetHeight - topMenu.offsetHeight - 28"
        [floorPlanItems]="service.floorPlans"
        [resourcesMap]="service.resourcesMap"
        [showDisabledTables]="false"
        [transformEnabled]="false"
        [customSelectMode]="true"
        [allowCustomSelection]="true"
        [allowMultiSelectByUser]="false"
        [allowDeselectionByUser]="false"
        [customMultiSelectEnabled]="true"
        [isOnFreePlan]="!isOnBusinessPlan"
        [getItems]="getItems"
        (updatePartyWithResource)="updatePartyWithResource($event)"
        (floorChanged)="floorChange($event)"
        (objectMultiSelected)="objectMultiSelected($event, searchTerm)"
        (clickedOnCanvas)="closePartyOrTableInfo()"
        (htmlDragStart)="isTabletLayout ? setSidebarOpen(false) : null"
      ></frontend-canvas>
    </div>
  </div>
</section>
